import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import Widgets from './domains/widgets';
import { DASHBOARDS_OVERLAY_ROOT_ID } from './shared/utils';

/**
 * Root component of the Widget Library / Widget Playground surface (CT-5183).
 *
 * Mounted by the Core Shell under <Route path="widgets/*">. It is a sibling of
 * {@link DashboardsApp} rather than a branch inside it: both are mounted under a
 * splat, so by the time either renders the segment that told them apart has
 * already been consumed by the parent route.
 *
 * Shares the `dashboards` i18n namespace and the Dashboards workspace, because
 * widgets are the tiles dashboards are composed of.
 */
const WidgetsApp = () => {
  const { ready } = useTranslation('dashboards');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        Loading…
      </div>
    );
  }

  return (
    <ToastProvider
      config={{
        position: 'top-right',
        defaultDuration: 4000,
        defaultMaxWidth: '600px',
        defaultMinWidth: '600px',
      }}
    >
      <div className="relative flex h-full flex-1 flex-col overflow-hidden">
        <Widgets />

        {/*
          Overlay root — the same one Governance and Agentic Studio mount.

          Panels portal in here rather than into `body`, which is what keeps
          their backdrop inside the content column instead of dimming the
          shell's top bar and module nav. `pointer-events-none` so an empty
          root does not swallow clicks on the page underneath; each panel
          re-enables hits on its own backdrop and surface.
        */}
        <div
          id={DASHBOARDS_OVERLAY_ROOT_ID}
          className="pointer-events-none absolute inset-0 z-[100] overflow-hidden"
          aria-hidden
        />
      </div>
    </ToastProvider>
  );
};

export default WidgetsApp;
